import styled, { css } from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { getLineHeight, getFontWeight } from './utils.js';
import { BoxPropsMapping } from '../Box/props.js';
import { spacing } from '../constants/spacing.js';

var fontFamilyStyles = function fontFamilyStyles(_ref) {
  var theme = _ref.theme;
  return css(["font-family:", ";"], theme.font.family);
};
var contentTextStyles = /*#__PURE__*/css(["", ";margin:0;line-height:", ";font-weight:", ";font-style:", ";"], fontFamilyStyles, function (p) {
  return getLineHeight({
    lineHeightMap: p.theme.contentText.web.lineHeights,
    lineHeight: p.lineHeight
  });
}, getFontWeight, function (props) {
  return props.italic ? 'italic' : 'normal';
});
var StyledContentText = /*#__PURE__*/styled.p.withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return !Object.keys(BoxPropsMapping).includes(prop) && defaultValidatorFn(prop);
  }
}).withConfig({
  displayName: "stylesweb__StyledContentText",
  componentId: "sc-1ku74p0-0"
})(["", ";margin-bottom:", ";text-align:inherit;", ";line-height:", ";"], contentTextStyles, function (props) {
  return props.paragraph ? spacing.xxs : 0;
}, boxStyles, function (p) {
  return getLineHeight({
    lineHeightMap: p.theme.contentText.web.lineHeights,
    lineHeight: p.lineHeight
  });
});

export { StyledContentText, contentTextStyles, fontFamilyStyles };
